import React, { FC } from 'react'

import DocumentHeader from 'components/DocumentHeader'

import { useGetTrash, GetTrashProps } from 'modules/shares/operations'

import EmptyState from '../EmptyState'
import LoadingState from '../LoadingState'
import TrashItemsLayout from '../TrashItemsLayout'

import { useForTablet, DocumentHead, ErrorMessage } from '@sketch/components'

const DELETE_PROJECT_DESCRIPTION =
  'Documents and projects in Trash are permanently deleted after 90 days.'

const TrashList: FC<GetTrashProps> = props => {
  const { workspaceId, search } = props
  const isTabletAndBigger = useForTablet()

  const result = useGetTrash({ workspaceId, search })

  if (!result || result.kind === 'error') {
    return <ErrorMessage.Generic />
  }

  if (result.kind === 'loading') return <LoadingState />

  const { fetchMore, items, loading, totalCount } = result

  if (!loading && items.length === 0) {
    return (
      <EmptyState
        search={search}
        title="Trash is empty"
        description={DELETE_PROJECT_DESCRIPTION}
        icon="trash-bin"
      />
    )
  }

  return (
    <>
      <DocumentHead title="Trash" />
      <TrashItemsLayout
        items={items}
        loading={loading}
        totalItemsCount={totalCount}
        onLoadMore={fetchMore}
        workspaceId={workspaceId}
        header={
          isTabletAndBigger && (
            <DocumentHeader
              title="Trash"
              description={DELETE_PROJECT_DESCRIPTION}
            />
          )
        }
      />
    </>
  )
}

export default TrashList
